import { default as _91_46_46_46slugs_93WrwO4fuOEOMeta } from "/home/ia/Desktop/projects/gumbati-nuxt/pages/[...slugs].vue?macro=true";
import { default as clear_45cacheGCjquvHLwNMeta } from "/home/ia/Desktop/projects/gumbati-nuxt/pages/clear-cache.vue?macro=true";
import { default as errory7RQLUiXGXMeta } from "/home/ia/Desktop/projects/gumbati-nuxt/pages/error.vue?macro=true";
import { default as indexRp6szPc2q3Meta } from "/home/ia/Desktop/projects/gumbati-nuxt/pages/index.vue?macro=true";
import { default as privacy_45policy_45testo18hHq6w98Meta } from "/home/ia/Desktop/projects/gumbati-nuxt/pages/privacy-policy-test.vue?macro=true";
export default [
  {
    name: _91_46_46_46slugs_93WrwO4fuOEOMeta?.name ?? "slugs___ka",
    path: _91_46_46_46slugs_93WrwO4fuOEOMeta?.path ?? "/ka/:slugs(.*)*",
    meta: _91_46_46_46slugs_93WrwO4fuOEOMeta || {},
    alias: _91_46_46_46slugs_93WrwO4fuOEOMeta?.alias || [],
    redirect: _91_46_46_46slugs_93WrwO4fuOEOMeta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/[...slugs].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slugs_93WrwO4fuOEOMeta?.name ?? "slugs___en",
    path: _91_46_46_46slugs_93WrwO4fuOEOMeta?.path ?? "/:slugs(.*)*",
    meta: _91_46_46_46slugs_93WrwO4fuOEOMeta || {},
    alias: _91_46_46_46slugs_93WrwO4fuOEOMeta?.alias || [],
    redirect: _91_46_46_46slugs_93WrwO4fuOEOMeta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/[...slugs].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slugs_93WrwO4fuOEOMeta?.name ?? "slugs___ru",
    path: _91_46_46_46slugs_93WrwO4fuOEOMeta?.path ?? "/ru/:slugs(.*)*",
    meta: _91_46_46_46slugs_93WrwO4fuOEOMeta || {},
    alias: _91_46_46_46slugs_93WrwO4fuOEOMeta?.alias || [],
    redirect: _91_46_46_46slugs_93WrwO4fuOEOMeta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/[...slugs].vue").then(m => m.default || m)
  },
  {
    name: clear_45cacheGCjquvHLwNMeta?.name ?? "clear-cache___ka",
    path: clear_45cacheGCjquvHLwNMeta?.path ?? "/ka/clear-cache",
    meta: clear_45cacheGCjquvHLwNMeta || {},
    alias: clear_45cacheGCjquvHLwNMeta?.alias || [],
    redirect: clear_45cacheGCjquvHLwNMeta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: clear_45cacheGCjquvHLwNMeta?.name ?? "clear-cache___en",
    path: clear_45cacheGCjquvHLwNMeta?.path ?? "/clear-cache",
    meta: clear_45cacheGCjquvHLwNMeta || {},
    alias: clear_45cacheGCjquvHLwNMeta?.alias || [],
    redirect: clear_45cacheGCjquvHLwNMeta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: clear_45cacheGCjquvHLwNMeta?.name ?? "clear-cache___ru",
    path: clear_45cacheGCjquvHLwNMeta?.path ?? "/ru/clear-cache",
    meta: clear_45cacheGCjquvHLwNMeta || {},
    alias: clear_45cacheGCjquvHLwNMeta?.alias || [],
    redirect: clear_45cacheGCjquvHLwNMeta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: errory7RQLUiXGXMeta?.name ?? "error___ka",
    path: errory7RQLUiXGXMeta?.path ?? "/ka/error",
    meta: errory7RQLUiXGXMeta || {},
    alias: errory7RQLUiXGXMeta?.alias || [],
    redirect: errory7RQLUiXGXMeta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/error.vue").then(m => m.default || m)
  },
  {
    name: errory7RQLUiXGXMeta?.name ?? "error___en",
    path: errory7RQLUiXGXMeta?.path ?? "/error",
    meta: errory7RQLUiXGXMeta || {},
    alias: errory7RQLUiXGXMeta?.alias || [],
    redirect: errory7RQLUiXGXMeta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/error.vue").then(m => m.default || m)
  },
  {
    name: errory7RQLUiXGXMeta?.name ?? "error___ru",
    path: errory7RQLUiXGXMeta?.path ?? "/ru/error",
    meta: errory7RQLUiXGXMeta || {},
    alias: errory7RQLUiXGXMeta?.alias || [],
    redirect: errory7RQLUiXGXMeta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/error.vue").then(m => m.default || m)
  },
  {
    name: indexRp6szPc2q3Meta?.name ?? "index___ka",
    path: indexRp6szPc2q3Meta?.path ?? "/ka",
    meta: indexRp6szPc2q3Meta || {},
    alias: indexRp6szPc2q3Meta?.alias || [],
    redirect: indexRp6szPc2q3Meta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexRp6szPc2q3Meta?.name ?? "index___en",
    path: indexRp6szPc2q3Meta?.path ?? "/",
    meta: indexRp6szPc2q3Meta || {},
    alias: indexRp6szPc2q3Meta?.alias || [],
    redirect: indexRp6szPc2q3Meta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexRp6szPc2q3Meta?.name ?? "index___ru",
    path: indexRp6szPc2q3Meta?.path ?? "/ru",
    meta: indexRp6szPc2q3Meta || {},
    alias: indexRp6szPc2q3Meta?.alias || [],
    redirect: indexRp6szPc2q3Meta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policy_45testo18hHq6w98Meta?.name ?? "privacy-policy-test___ka",
    path: privacy_45policy_45testo18hHq6w98Meta?.path ?? "/ka/privacy-policy-test",
    meta: privacy_45policy_45testo18hHq6w98Meta || {},
    alias: privacy_45policy_45testo18hHq6w98Meta?.alias || [],
    redirect: privacy_45policy_45testo18hHq6w98Meta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/privacy-policy-test.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policy_45testo18hHq6w98Meta?.name ?? "privacy-policy-test___en",
    path: privacy_45policy_45testo18hHq6w98Meta?.path ?? "/privacy-policy-test",
    meta: privacy_45policy_45testo18hHq6w98Meta || {},
    alias: privacy_45policy_45testo18hHq6w98Meta?.alias || [],
    redirect: privacy_45policy_45testo18hHq6w98Meta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/privacy-policy-test.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policy_45testo18hHq6w98Meta?.name ?? "privacy-policy-test___ru",
    path: privacy_45policy_45testo18hHq6w98Meta?.path ?? "/ru/privacy-policy-test",
    meta: privacy_45policy_45testo18hHq6w98Meta || {},
    alias: privacy_45policy_45testo18hHq6w98Meta?.alias || [],
    redirect: privacy_45policy_45testo18hHq6w98Meta?.redirect || undefined,
    component: () => import("/home/ia/Desktop/projects/gumbati-nuxt/pages/privacy-policy-test.vue").then(m => m.default || m)
  }
]